<template>
  <div id="app">
    <Navigation class="navigation">
    <template v-if="!isMobile">
        <BarItem path="/">
          <span slot="item-text">{{ $t("home") }}</span>
        </BarItem>
        <BarItem path="/about">
          <span slot="item-text">{{ $t("about") }}</span>
        </BarItem>
        <BarItem path="/news">
          <span slot="item-text">{{ $t("news") }}</span>
        </BarItem>
        <BarItem path="/products">
          <span slot="item-text">{{ $t("products") }}</span>
        </BarItem>
        <BarItem path="/contact">
          <span slot="item-text">{{ $t('contact') }}</span>
        </BarItem>
      </template>

      <template v-else>
        <div class="menu-icon" @click="toggleMenu" :style="{ color: menuIconColor }">
    <span>{{ $t("mbmenu") }}</span>
  </div>
        <div v-if="menuVisible" class="submenu">
          <BarItem path="/">
            <span slot="item-text">{{ $t("home") }}</span>
          </BarItem>
          <BarItem path="/about">
            <span slot="item-text">{{ $t("about") }}</span>
          </BarItem>
          <BarItem path="/news">
            <span slot="item-text">{{ $t("news") }}</span>
          </BarItem>
          <BarItem path="/products">
            <span slot="item-text">{{ $t("products") }}</span>
          </BarItem>
          <BarItem path="/contact">
            <span slot="item-text">{{ $t('contact') }}</span>
          </BarItem>
        </div>
      </template>
    </Navigation>

    <router-view></router-view>
    <div @click="goBack">
      <PhoneIcon
        bottom="31vh"
        right="3vw"
        backgroundImage="goback.png"
        :infoContent="{ email: $t('goBack') }"
        data-aos="fade-left"
      />
    </div>
    <router-link to="/contact">
      <PhoneIcon
        bottom="24vh"
        right="3vw"
        backgroundImage="call.png"
        :infoContent="{ email: $t('contact') }"
        data-aos="fade-left"
      />
    </router-link>
    <router-link to="/join">
      <PhoneIcon
        bottom="17vh"
        right="3vw"
        backgroundImage="add.png"
        :infoContent="{ email: $t('join') }"
        data-aos="fade-left"
      />
    </router-link>
    <PhoneIcon
      bottom="10vh"
      right="3vw"
      backgroundImage="link.png"
      :infoContent="{ email: $t('email'), phone: $t('phone') }"
      data-aos="fade-left"
    />
    <Footer></Footer>
  </div>
</template>

<script>
import Navigation from "./components/tabbar/Navigation.vue";
import BarItem from "./components/tabbar/BarItem.vue";
import Footer from "./components/Footer.vue";
import PhoneIcon from "./components/PhoneIcon.vue";

export default {
  name: "App",
  data() {
    return {
      isMobile: false,
      menuVisible: false,
      menuIconColor: "#f9f9f9",
    };
  },
  components: {
    Navigation,
    BarItem,
    Footer,
    PhoneIcon,
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 判断屏幕宽度，768px以下为手机
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible; // 切换菜单的显示与隐藏
    },
    
    goBack() {
      const currentPath = this.$route.path;
      // 判断当前路径是否是主页面
      if (
        currentPath === "/" ||
        currentPath === "/home" ||
        currentPath === "/en/" ||
        currentPath === "/en/home"
      ) {
        // 如果在主页面，则不执行返回操作
        return;
      } else {
        // 如果不在主页面，则返回上一页
        this.$router.back();
      }
    },
    handleScroll() {
    // 修改 menuIconColor 的颜色值根据滚动位置
    const vw = window.innerWidth / 100;
    this.menuIconColor = window.scrollY > (30 * vw) ? "#00000090" : "#fff";
  },

    // goTo(path) {
    // this.$router.push({
    //   path: `/${this.$i18n.locale}${path}`
    // });
    // },
  },
};
</script>

<style>
@import "./css/base.css";

@media (max-width: 768px) {
.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.menu-icon {
  cursor: pointer;
  color: #f9f9f9;
  text-align: right;
  position: absolute;
  right: 120px;
  top: 20px;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue